const footnotes = {
  2019: 'The low rate threshold is $205,000 for 2018/19.',
  2020: 'The low rate threshold is $210,000 for 2019/20.',
  2021: 'The low rate threshold is $215,000 for 2020/21.',
  default: 'The low rate threshold is $225,000 for 2021/22.',
};

export default {
  name: 'pds-2021',
  computed: {
    fund() {
      return this.$store.getters['fund/getFund'];
    },
    fundName() {
      return this.fund.details.name;
    },
    formatTrusteesAsList() {
      return this.fund.trustee.trustees.flatMap(
        trustee => `${trustee.firstName} ${trustee.lastName}`,
      );
    },
    pensionKit() {
      return this.$store.getters['toolkit/getItemData'];
    },
    startDate() {
      return this.pensionKit.requirements.startDate;
    },
    startDateObject() {
      return new Date(this.pensionKit.requirements.startDate);
    },
    getFinYear() {
      let finYearStart = new Date(this.startDateObject.getFullYear(), 6, 1);
      let dateToConsider = this.startDateObject;
      if (this.pensionKit.requirements.ratify) {
        finYearStart = new Date(new Date().getFullYear(), 6, 1);
        dateToConsider = new Date();
      }
      if (dateToConsider < finYearStart) {
        return dateToConsider.getFullYear();
      }
      return dateToConsider.getFullYear() + 1;
    },
    tris() {
      return (
        this.pensionKit.requirements.eligibility.reasons === 'The pension will be a transition to retirement pension'
      );
    },
    footnoteThreeText() {
      if (this.getFinYear <= 2019) {
        return footnotes[2019];
      }
      if (this.getFinYear >= 2022) {
        return footnotes.default;
      }
      if (footnotes[this.getFinYear] !== undefined) {
        return footnotes[this.getFinYear];
      }
      return footnotes.default;
    },
  },
};
